import { object, string, array, boolean } from 'yup';
import type { TeamID } from '@common/ids';
import { convertSnakeCaseIntoCamelCase, makeUUIDSchema } from './helper';

//from eden: src/app/global/definitions/interfaces/services/database/index.ts
// export interface APIOpponentTeam {
//     root_team_id: TeamId;
//     owning_team_id: TeamId;
//     progenitor_team_id?: TeamId;
//     name: string;
//     is_hidden: boolean;
// }
export const APIOpponentTeamSchema = object({
    rootTeamID: makeUUIDSchema<TeamID>().required(),
    owningTeamID: makeUUIDSchema<TeamID>().required(),
    progenitorTeamID: makeUUIDSchema<TeamID>(),
    name: string().required(),
    isHidden: boolean().required(),
}).transformKeys(convertSnakeCaseIntoCamelCase);

export const APIOpponentTeamListSchema = array(APIOpponentTeamSchema).required();
